import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';
import {
  DeclarativeMapCanvasComponent,
  DeclarativeMapMarkerComponent,
  DeclarativeMapMarkerTemplateDirective,
} from '@cue/map/elements';
import { cueCircle, cueQrCode, cueStart, IconComponent } from '@cue/ui/icons';
import { translation } from '@cue/translations';
import { LocalizedString, UnitWatchdogService } from '@cue/api';
import { LocalizedStringPipe } from '@cue/utilities';

export type MapPortalPoint = {
  index: number;
  newAreaId?: number;
  newGroupIdx?: number;
  name: LocalizedString;
  zoomPOI: boolean;
  poiSize: number;
  x: number;
  y: number;
  icon: string | null;
};

@Component({
  selector: 'cue-map-portal',
  imports: [DeclarativeMapMarkerComponent, DeclarativeMapMarkerTemplateDirective, LocalizedStringPipe, IconComponent],
  templateUrl: './map-portal.component.html',
  styleUrl: './map-portal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class MapPortalComponent {
  ICONS = {
    cueStart,
    cueQrCode,
    cueCircle,
  };

  canvas = inject(DeclarativeMapCanvasComponent);
  private unitWatchdogService = inject(UnitWatchdogService);

  zoom = computed(() => {
    return this.canvas.zoom();
  });
  click = output();

  portalPoint = input<MapPortalPoint>();

  isFirstPortalOfArea = input<boolean>();
  readonly isPanel = this.unitWatchdogService.isUserAgentFromUnit();

  geoJson = computed(() => {
    if (!this.portalPoint()) return null;
    return {
      type: 'Point',
      coordinates: [this.portalPoint()?.y, this.portalPoint()?.x],
    };
  });

  focused = input<boolean, boolean | 'true' | 'false'>(false, {
    transform: booleanAttribute,
  });

  sizeCoefficient = computed(() => {
    return this.portalPoint()?.poiSize ?? 1;
  });

  scale = computed(() => {
    if (this.focused()) return 1.25;
    if (this.zoom() >= 0.5) {
      return this.sizeCoefficient() * this.zoom();
    } else {
      return this.sizeCoefficient() * 0.5;
    }
  });

  onHostClick(ev: MouseEvent) {
    ev.stopPropagation();
    this.click.emit();
  }

  protected readonly translation = translation;
}
